export default "__VITE_ASSET__DxunnVgA__"